import EnvUtil from '../util/EnvUtil'
import { gsap } from 'gsap'


class NavItem
{
  // ---------------------------------------------------------------------------------------------------------
	// --	NavItem
	// ---------------------------------------------------------------------------------------------------------

  constructor(){

    //初期化フラグ
    this.isInit = false

    //PC版は初期化
    if(EnvUtil.isPC())
    {
      this.init()
    }
    //SP版の時はPC版になってから初期化
    else
    {
      $(window).on('resize', this.init)
    }
  }

  init()
  {
    if(this.isInit || EnvUtil.isSP()) return

    //リスナー削除
    $(window).off('resize', this.init)

    //フラグを立てる
    this.isInit = true

    //IE対策でサイズ固定
    $('.nav__item').each(function(index)
    {
      const w = $(this).width()
      const h = $(this).height()
      $(this).css('width', (w + 5) + 'px')
      $(this).css('height', h + 'px')
    })

    //一文字づつ分割
    $('.nav__item >a').lettering()

    //演出用にDOM構築
    $('.nav__item >a >span').each(function(index)
    {
      let str = $(this).text()
      $(this).empty()
      $(this).append("<span class='js-org'>" + str + "</span>")
      $(this).append("<span class='js-bk-mask'><span class='js-bk-mask-inner'>" + str + "</span></span>")
      $(this).append("<span class='js-mask'><span class='js-mask-inner'>" + str + "</span></span>")

      const org = $(this).find('.js-org')
      const bkmask = $(this).find('.js-bk-mask')
      const bkinner = $(this).find('.js-bk-mask-inner')
      const mask = $(this).find('.js-mask')
      const inner = $(this).find('.js-mask-inner')

      const w = org.width()
      const h = org.height()

      bkmask.css('width', w + 'px')
      bkmask.css('height', h + 'px')

      mask.css('width', w + 'px')
      mask.css('height', 0 + 'px')
    })


    //ボタンアクション
    $('.nav__item >a').each(function(index){

      //ロールオーバー
      $(this).hover(()=>{
        if(EnvUtil.isSP()) return
        $(this).find(">span").each(function(index2){

          const org = $(this).find('.js-org')
          const bkmask = $(this).find('.js-bk-mask')
          const bkinner = $(this).find('.js-bk-mask-inner')
          const mask = $(this).find('.js-mask')
          const inner = $(this).find('.js-mask-inner')

          if(index2%2 == 0)
          {
            bkmask.css('top', 'auto')
            bkmask.css('bottom', '0')
            bkinner.css('top', 'auto')
            bkinner.css('bottom', '0')
  
            mask.css('top', '0')
            mask.css('bottom', 'auto')
            inner.css('top', '0')
            inner.css('bottom', 'auto')
          }
          else
          {
            bkmask.css('top', '0')
            bkmask.css('bottom', 'auto')
            bkinner.css('top', '0')
            bkinner.css('bottom', 'auto')
  
            mask.css('top', 'auto')
            mask.css('bottom', '0')
            inner.css('top', 'auto')
            inner.css('bottom', '0')
          }

          const h = org.height()

          gsap.killTweensOf(mask)
          gsap.to(mask, 0.3, {
            height    : h + 'px',
            delay     : 0.03 * index2
          })
          gsap.killTweensOf(bkmask)
          gsap.to(bkmask, 0.3, {
            height    : 0 + 'px',
            delay     : 0.03 * index2
          })
        })

      //ロールアウト
      }, ()=>{
        $(this).find(">span").each(function(index2){

          const org = $(this).find('.js-org')
          const bkmask = $(this).find('.js-bk-mask')
          const bkinner = $(this).find('.js-bk-mask-inner')
          const mask = $(this).find('.js-mask')
          const inner = $(this).find('.js-mask-inner')

          bkmask.css('top', '0')
          bkmask.css('bottom', 'auto')
          bkinner.css('top', '0')
          bkinner.css('bottom', 'auto')

          mask.css('top', 'auto')
          mask.css('bottom', '0')
          inner.css('top', 'auto')
          inner.css('bottom', '0')

          const h = org.height()
          
          gsap.killTweensOf(mask)
          gsap.to(mask, 0.3, {
            height    : '0px',
            delay     : 0.02 * index2
          })
          gsap.killTweensOf(bkmask)
          gsap.to(bkmask, 0.3, {
            height    : h + 'px',
            delay     : 0.02 * index2
          })
        })
      })
    })
  }

  
	// ---------------------------------------------------------------------------------------------------------
}

export default NavItem